import { getThreadId } from 'find-and-filter-data/view-members-schema/protected';
import get from 'transmute/get';
export const getThreadUpdateAudit = get('audit');
export const getThreadUpdateMembers = get('members');
export const getThreadUpdateThreadIds = update => {
  const members = getThreadUpdateMembers(update);
  return members.map(member => getThreadId(member));
};